// extracted by mini-css-extract-plugin
export default {"root":"EntityPickerTabBar_root__3bZim","inner":"EntityPickerTabBar_inner__6YLRf"};